import jQuery from 'jquery';
import _ from 'lodash';
//import GridStackUI from 'gridstack';
//import GridStackUI from '../../../../../scripts/gridstack';
import { Draggable } from '@shopify/draggable';
const GridStackUI = require('./gridstack');
const resizable = require('./jquery-resizable');

/**
 * gridstack.js 1.0.0-dev
 * http://troolee.github.io/gridstack.js/
 * (c) 2014-2017 Pavel Reznikov, Dylan Weiss
 * gridstack.js may be freely distributed under the MIT license.
 * @preserve
*/
(function(factory) {
    factory(jQuery, _, window.GridStackUI);
})(function($, _, GridStackUI) {

    //var scope = window;
    let draggable;
    /**
    * @class DraggableGridStackDragDropPlugin
    * jQuery UI implementation of drag'n'drop gridstack plugin.
    */
    function DraggableGridStackDragDropPlugin(grid) {
        GridStackUI.GridStackDragDropPlugin.call(this, grid);
    }

    GridStackUI.GridStackDragDropPlugin.registerPlugin(DraggableGridStackDragDropPlugin);

    DraggableGridStackDragDropPlugin.prototype = Object.create(GridStackUI.GridStackDragDropPlugin.prototype);
    DraggableGridStackDragDropPlugin.prototype.constructor = DraggableGridStackDragDropPlugin;

    DraggableGridStackDragDropPlugin.prototype.resizable = function(el, opts) {
        el = $(el);
        if (opts === 'disable' || opts === 'enable') {
            //el.resizable(opts);
        } else if (opts === 'option') {
            //this call gives us the minWidth and minHeight, we don't currently need this
            /*var key = arguments[2];
            var value = arguments[3];
            el.resizable(opts, key, value);*/
        } else {
            //var handles = el.data('gs-resize-handles') ? el.data('gs-resize-handles') : this.grid.opts.resizable.handles;
            el.resizable(_.extend({}, this.grid.opts.resizable, {
                handleSelector: '> .ui-resizable-handle'
            }, {
                onDragStart: function (e, $el, opt) {
                    const ui = {
                        helper: $el,
                        originalPosition: $el.position(),
                        position: $el.position()
                    }
                    el.parent().addClass('grid-stack--dragging');
                    console.log('resize start: ' + ui);
                    const event = cloneEvent('resizestart', e);
                    //we use the call function so the 'this' element is set to the original element
                    opts.start.call($el, event, ui);
                },
                onDragEnd: function (e, $el, opt) {
                    const ui = {
                        helper: $el,
                        originalPosition: $el.position(),
                        position: $el.position()
                    }
                    el.parent().removeClass('grid-stack--dragging');
                    console.log('resize stop: ' + ui);
                    const event = cloneEvent('resizestop', e);
                    //we use the call function so the 'this' element is set to the original element
                    opts.stop.call($el, event, ui);
                },
                onDrag: function (e, $el, newWidth, newHeight, opt) {
                    const ui = {
                        helper: $el,
                        originalPosition: $el.position(),
                        position: $el.position(),
                        size: {
                            width: newWidth,
                            height: newHeight
                        }
                    }
                    console.log('resize: ' + ui);
                    const event = cloneEvent('resize', e);
                    //we use the call function so the 'this' element is set to the original element
                    opts.resize.call($el, event, ui);
                }
            }));
        }
        return this;
    };

    function cloneEvent(type, event) {
        var evt = new Event(type);
        return Object.setPrototypeOf(evt,event);
    }

    function isPrevented(element, classesToPrevent) {
        let currentElem = element;
        let isParent = false;
        
        while (currentElem) {
          const hasClass = Array.from(currentElem.classList).some((cls) => classesToPrevent.includes(cls));
          if (hasClass) {
            isParent = true;
            currentElem = undefined;
          } else {
            currentElem = currentElem.parentElement;
          }
        }
        
        return isParent;
    }

    DraggableGridStackDragDropPlugin.prototype.draggable = function(el, opts) {
        el = $(el);
        if(el.hasClass('grid-stack-item-draggable')) {
            let leftOffset = 0;
            let topOffset = 0;
            if (opts === 'disable' || opts === 'enable') {
                //el.draggable(opts);
            } else {        
                if(!draggable) {
                    draggable = new Draggable(el.parent()[0], {
                        handle: this.grid.opts.draggable.handle,
                        draggable: '.grid-stack-item-draggable'
                    })
                }
                draggable.on('drag:start', (dragEvent) => {                    
                    if(opts.start) {
                        const currentTarget = dragEvent.originalEvent.target;  
                        if (isPrevented(currentTarget, ['grid-actions','select2'])) {
                            dragEvent.cancel();
                        }
                        else {                            
                            el.parent().addClass('grid-stack--dragging');
                            const originalElement = $(dragEvent.originalSource);
                            const source = $(dragEvent.source);
                            const ui = {
                                helper: originalElement,
                                originalPosition: source.position(),
                                position: source.position()
                            }
                            console.log('drag start: ' + ui);
                            //get the difference between the top/left edges of the control as our mouse, we'll need these to adjust the position for the movements
                            leftOffset = dragEvent.sensorEvent.clientX - ui.position.left;
                            topOffset = dragEvent.sensorEvent.clientY - ui.position.top;
                            const event = cloneEvent('dragstart', dragEvent.originalEvent);
                            //we use the call function so the 'this' element is set to the original element
                            opts.start.call(originalElement, event, ui);
                        }
                    }
                })
                .on('drag:stop', (dragEvent) => {
                    if(opts.stop) {
                        el.parent().removeClass('grid-stack--dragging');
                        const originalElement = $(dragEvent.originalSource);
                        const source = $(dragEvent.source);
                        const ui = {
                            helper: originalElement,
                            originalPosition: source.position()
                        }     
                        const event = cloneEvent('dragstop', dragEvent.originalEvent);               
                        opts.stop.call(originalElement, event, ui);
                    }
                })
                .on('drag:move', (dragEvent) => {
                    if(opts.drag) {
                        const originalElement = $(dragEvent.originalSource);
                        const source = $(dragEvent.source);

                        const ui = {
                            helper: originalElement,
                            originalPosition: source.position(),
                            position: {
                                left: dragEvent.sensorEvent.clientX - leftOffset,
                                top: dragEvent.sensorEvent.clientY - topOffset
                            } 
                        }
                        console.log('drag move: ' + ui);
                        const event = cloneEvent('drag', dragEvent.originalEvent);
                        opts.drag.call(originalElement, event, ui);
                    }
                })
            }
        }
        return this;
    };

    DraggableGridStackDragDropPlugin.prototype.droppable = function(el, opts) {
        el = $(el);
        el.droppable(opts);
        return this;
    };

    DraggableGridStackDragDropPlugin.prototype.isDroppable = function(el, opts) {
        el = $(el);
        return Boolean(el.data('droppable'));
    };

    DraggableGridStackDragDropPlugin.prototype.on = function(el, eventName, callback) {
        $(el).on(eventName, callback);
        return this;
    };

    return DraggableGridStackDragDropPlugin;
});